module.exports = __webpack_public_path__ + "img/kim-liggett.398245ae.png";